import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Toilet.svg",
  "use": "Toilet.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Toilet.svg\"><path d=\"M26,34V33a2,2,0,0,1,2-2H48a2,2,0,0,1,2,2v1a1,1,0,0,1-1,1H27A1,1,0,0,1,26,34Zm-4,1H16a2,2,0,0,1-2-2V10a2,2,0,0,1,2-2h6a2,2,0,0,1,2,2V33A2,2,0,0,1,22,35ZM46,55a1,1,0,0,1-1,1H23a1,1,0,0,1-1-1c0-2.5766,4-2.75,4-5,0-2.75-8-3.9291-8-12a1,1,0,0,1,1-1H49a1,1,0,0,1,1,1c0,8.071-8,9.25-8,12C42,52.25,46,52.4234,46,55Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol